import { useCallback } from "react"
import { Button, Stack, useMediaQuery, useTheme } from "@mui/material"
import { ShareButton } from "components/Button"
import { useTranslation } from "react-i18next"
import { PlaceIcon } from "components/icons"
import { useNavigate } from "react-router-dom"
import { gtmPushDataLayerViewReservation } from "utils/googletagmanager/viewReservation"

export const FeatureActionContainer = ({
  originId = "unknown",
  destinationId,
  ShareProps,
  DirectionButtonProps,
  onNavigate,
  canReserve = false,
  isComingSoon = false,
  feature,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    icon = <PlaceIcon />,
    label = "Directions",
    isHidden = false,
    ...restDirectionButtonProps
  } = DirectionButtonProps || {}
  const isMobileOrTablet = useMediaQuery("(max-width: 991px)")
  const buttonSize = isMobileOrTablet ? "small" : "medium"
  const theme = useTheme()
  const {
    shortInfoActionWrapper,
    navigationButton,
    actionButton,
    reservationButton,
    comingSoonButton,
  } = theme.components[`FeatureActionContainer`]?.styleOverrides || {}

  const handleClickReservation = useCallback(() => {
    gtmPushDataLayerViewReservation(feature)
    navigate(`/maps/place/${destinationId}/reservation`)
  }, [feature, destinationId, navigate])

  return (
    <Stack
      className="FeatureActionContainer-root"
      direction="row"
      spacing={1}
      sx={shortInfoActionWrapper}
    >
      {isComingSoon && (
        <Button
          size={buttonSize}
          disabled
          variant="contained"
          sx={comingSoonButton}
        >
          {t("Coming soon")}
        </Button>
      )}
      <Button
        id="get-direction-button"
        data-testid="get-direction-button"
        variant="contained"
        startIcon={icon}
        size={buttonSize}
        {...restDirectionButtonProps}
        onClick={onNavigate}
        sx={{
          ...navigationButton,
          visibility: isHidden ? "hidden" : "visible",
        }}
      >
        {t(label)}
      </Button>
      {canReserve && !isComingSoon && (
        <Button
          size={buttonSize}
          sx={reservationButton}
          onClick={handleClickReservation}
        >
          {t("Reservation")}
        </Button>
      )}
      {navigator.share && (
        <ShareButton
          size={buttonSize}
          url={window.location.href}
          label=""
          sx={actionButton}
          {...ShareProps}
        />
      )}
    </Stack>
  )
}
